import classNames from 'classnames';
import { useState, useEffect } from 'react';
import { ReactComponent as ArrowTopRight } from '../../../assets/icons/arrow-top-right.svg';
import { FormattedMessage } from '../../../util/reactIntl';
import NamedLink from '../../NamedLink/NamedLink';
import ProductList from './ProductList/ProductList';
import css from './TabbedProductList.module.css';

const TabbedProductList = ({
  title,
  listings,
  hideActionButton,
  onLightBackground,
  fullWidthTabs,
  onCloseListing,
  onTabChange,
  initialTab,
  location,
  history,
  onDiscardDraftListing,
  isNewArrivals,
  isLeague,
  isProfilePage,
  isLandingPage
}) => {

  const defaultTab = 'for-sale';
  // Use initialTab from URL if provided, otherwise use first listing
  const [activeTab, setActiveTab] = useState(
    initialTab && listings.some(x => x.id === initialTab)
      ? initialTab
      : defaultTab
  );
  // Notify parent of initial tab selection
  useEffect(() => {
    if (!location || !history) return;

    const currentSearch = location.search || '';

    // if no tab/page in url -> add default
    if (!currentSearch.includes('tab=')) {
      history.replace({
        pathname: location.pathname,
        search: '?tab=for-sale&page=1',
      });
    }
  }, []);

  const handleTabChange = tabId => {
    setActiveTab(tabId);

    if (location && history) {
      history.push({
        pathname: location.pathname,
        search: `?tab=${tabId}&page=1`,
      });
    }

    if (onTabChange) {
      const tabData = listings.find(item => item.id === tabId);

      if (tabData?.leagueId) {
        onTabChange(tabData.leagueId);
      }
    }
  };

  const activeListing = listings.find(item => item.id === activeTab);
  return (
    <div className={css.wrapper}>
      {title && (
        <div
          className={
            isLeague
              ? css.title2
              : css.title
          }
        >
          <h3>{title}</h3>
        </div>
      )}

      {!isNewArrivals && (
        <div className={css.tabsContainer}>
          <ul className={classNames(css.tabs, { [css.fullWidthTabs]: fullWidthTabs })}>
          {listings.map(listing => (
            <li key={`tab-${listing.id}`}>
              <button
                onClick={() => handleTabChange(listing.id)}
                className={classNames(css.tabButton, {
                  [css.tabButtonActive]: activeTab === listing.id,
                  [css.onLightBackground]: onLightBackground || isLeague,
                  [css.isLeagueTab]: isLeague,
                })}
              >
                <FormattedMessage id={listing.tabNameIntlId} />
              </button>
            </li>
          ))}
        </ul>
        </div>
      )}

      {activeListing && (
        <ProductList
          key={activeListing.id}
          isLeague={isLeague}
          listing={{
            listings: activeListing.listings || [],
            count:
              activeListing.count ??
              activeListing.listings?.length ??
              0,
            currentPage:
              activeListing.currentPage || 1,
            totalPages:
              activeListing.totalPages || 1,
            noListingsTitle:
              activeListing.noListingsTitle ||
              'ProfilePage.Jersies.NoListingsTitle',
            noListingsText:
              activeListing.noListingsText ||
              'ProfilePage.Jersies.NoListingsText',
            ...activeListing
          }}
          onCloseListing={onCloseListing}
          onDiscardDraftListing={onDiscardDraftListing}
          isActive
          isLandingPage={isLandingPage}
          isProfilePage={isProfilePage}
        />
      )}

      {!hideActionButton && (
        <div className={css.actions}>
          <NamedLink className={isNewArrivals ? css.secondaryButton : isLeague ? css.secondaryButton3 : css.secondaryButton2} name="SearchPage" to={{ search: '?pub_for_sale_option=for_sale&scope=forSale&sort=createdAt' }}>
            <FormattedMessage id={'TabbedProductList.ShowAll'} /> <ArrowTopRight />
          </NamedLink>
        </div>
      )}
    </div>
  );
};

export default TabbedProductList;
